import React from 'react'

const NoAccessMessage = () => {
  return (
    <div className="products-heading" style={{display:"flex", alignItems:"center", justifyContent:"center", height:"100vh"}}>
      CON QUESTA TIPOLOGIA DI ACCOUNT NON AVETE ACCESSO A QUESTA PAGINA O DATI.
    </div>
  )
}

export default NoAccessMessage
